import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import PermanentActiveContent from "./PermanentActiveContent";
import permanentJobProfileType from "../types/permanentJobProfileType";
import errorsType from "../types/errorsType";
import tooltips from "./tooltips";
import {
  Label,
  LabelText,
  LabelIcon,
  RadioButtonGroup,
  RadioButtonWrapper,
  RadioButton,
  RadioButtonLabel,
  Check,
} from "../styles/edit-form-styles";

class Permanent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeRadioButtonID: "",
    };
  }

  componentDidMount() {
    this.selectRangeSalary();
  }

  componentWillUnmount() {
    this.selectRangeSalary();
  }

  selectRangeSalary = () => {
    const { jobProfile } = this.props;
    const { salaryType } = jobProfile;

    if (salaryType === "range") {
      this.setState({ activeRadioButtonID: "range" });
    }
  };

  handleRadioButton = (e) => {
    const { salaryTypeOnChange } = this.props;

    this.setState({ activeRadioButtonID: e.target.id });
    salaryTypeOnChange(e);
  };

  render() {
    const { activeRadioButtonID } = this.state;
    const { inputOnChange, jobProfile, errors, currencyOptions } = this.props;
    const {
      salaryMin,
      salaryMax,
      recruiterFeePercentage,
      salaryType,
      jobType,
      currencySymbol,
      currencyId,
    } = jobProfile;

    return (
      <Fragment>
        {jobType === "permanent" && (
          <Fragment>
            <Label htmlFor="salary-type">
              <LabelText>Salary type</LabelText>
              <LabelIcon>
                <FontAwesomeIcon
                  data-tip={tooltips.salaryType}
                  data-for="salary-type-tooltip"
                  icon={faInfoCircle}
                />
                <ReactTooltip
                  place="left"
                  type="dark"
                  effect="solid"
                  aria-haspopup="true"
                  id="salary-type-tooltip"
                />
              </LabelIcon>
            </Label>
            <RadioButtonGroup>
              <RadioButtonWrapper>
                <RadioButton
                  onChange={this.handleRadioButton}
                  name="salaryType"
                  id="fixed"
                  checked={salaryType === "fixed"}
                  type="radio"
                />
                <RadioButtonLabel htmlFor="fixed">Fixed</RadioButtonLabel>
                <Check />
              </RadioButtonWrapper>
              <RadioButtonWrapper>
                <RadioButton
                  onChange={this.handleRadioButton}
                  name="salaryType"
                  id="range"
                  checked={salaryType === "range"}
                  type="radio"
                />
                <RadioButtonLabel htmlFor="range">Range</RadioButtonLabel>
                <Check />
              </RadioButtonWrapper>
            </RadioButtonGroup>
          </Fragment>
        )}
        <PermanentActiveContent
          activeRadioButtonID={activeRadioButtonID}
          salaryMin={salaryMin}
          salaryMax={salaryMax}
          inputOnChange={inputOnChange}
          recruiterFeePercentage={recruiterFeePercentage}
          errors={errors}
          currencySymbol={currencySymbol}
          currencyId={currencyId}
          currencyOptions={currencyOptions}
        />
      </Fragment>
    );
  }
}

Permanent.propTypes = {
  inputOnChange: PropTypes.func.isRequired,
  salaryTypeOnChange: PropTypes.func.isRequired,
  jobProfile: permanentJobProfileType.isRequired,
  errors: errorsType.isRequired,
};

export default Permanent;
